import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { TSegmentDeclaration } from '../types';

import { segmentsQueryKeys } from './query-keys';

export async function deleteSegmentDeclaration(id: string): Promise<TSegmentDeclaration[]> {
  return mediaManagerClient.delete(`/api/v1/segment_declarations/${id}`).then(({ data }) => data);
}

type MutationFn = typeof deleteSegmentDeclaration;

type TUseDeleteSegmentDeclarationParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteSegmentDeclaration({ config }: TUseDeleteSegmentDeclarationParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: deleteSegmentDeclaration,
    onError(error) {
      addErrorNotification(t('No se ha podido eliminar la declaración del segmento'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('La declaración del segmento se ha eliminado correctamente'));
      queryClient.invalidateQueries({ queryKey: segmentsQueryKeys.segmentDeclaration });
    },
  });
}
